var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { faComments } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from 'react';
import CodeForm from "../CodeForm";
import { useHostValue } from "../Contexts/HostContext";
import { GoogleEvent, sendGtmEvent } from "../GoogleTagManager";
import Price from "../Host/Price";
import CallToActionText from "./CallToActionText";
import { useRouteMatch } from 'react-router';
import * as HostStates from '../Types/HostStateTypes';
var MobileFooter = function () {
  var routeMatch = useRouteMatch("/profil/:name/");
  var state = useHostValue()[0];
  if (routeMatch === null) {
    return null;
  }
  var name = routeMatch.params.name;
  var currentHost = state.hosts.find(function (host) {
    return host.name === name;
  });
  if (currentHost === undefined) {
    return null;
  }
  if (HostStates.isOffline(currentHost)) {
    return /*#__PURE__*/React.createElement("div", {
      id: 'mobileFooter',
      className: 'text-center c-mobile-footer'
    }, /*#__PURE__*/React.createElement("h3", null, "Momentan kein Telefonsex m\u00F6glich"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: '#webpushanchor'
    }, "Lass dich benachrichtigen"), ", wenn ich wieder da bin!"));
  }
  if (currentHost.status === HostStates.VIDEOCHAT) {
    return /*#__PURE__*/React.createElement("div", {
      id: 'mobileFooter',
      className: 'text-center  c-mobile-footer'
    }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faComments
    }), " Jetzt im Live-Chat"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      href: "https://www.flibzee.com/BAS/Videochat?s=".concat(currentHost.id, "&").concat(window.ladd),
      rel: 'noopener',
      onClick: function () {
        sendGtmEvent(GoogleEvent.PROFILE_BUTTON_TO_VX, currentHost.id);
      }
    }, "Komm in meinen Chat")));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: 'mobileFooter',
    className: 'c-mobile-footer'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement(CallToActionText, __assign({}, currentHost))), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "pineingabe"
  }, "Gib hier meinen Livecam-Code ein:")), /*#__PURE__*/React.createElement(CodeForm, {
    position: "sticky"
  }))), /*#__PURE__*/React.createElement(Price, null));
};
export default MobileFooter;